import { Modules } from "@/modules/module-list";
import { getMenu } from "../wp/getMenu";
import { GetStaticPropsContext } from "next";
import { CategoryType, MenuType, OptionsType } from "../types/baseTypes";
import { globalGetStaticPaths } from "../wp/globalGetStaticPaths";
import { globalGetPageData } from "../wp/globalGetPageData";
import { log, LogLevel } from "@/utils/logger";
import { HeadMeta } from "../components/Header/Head";
import { getRelativePathFromLink, isValidWpSlug } from "../utils/url";
import { hasChildPages } from "../wp/hasChildren";
import {
  getFooterOptions,
  getHeadersOptions,
  getIconsOptions,
  getModuleOptions,
} from "../getData/getModuleOptions";
import {
  ModuleOptionsType,
  HeadersOptionsType,
  StartPageType,
  IconsType,
  popupOptionType,
} from "@/types/ModuleOptionsType";
import { filterObjectByArrayKeys } from "../utils/filterObjectByArrayKeys";
import { getThemeOptions } from "../wp/getOptions";
import {
  LabelsType,
  NewsLetterOptionType,
  OptionsEndCardsType,
  OptionsFooterType,
  OptionsGoogleMapType,
  OptionsHeaderType,
  OptionsSearchType,
  OptionsSecurityHeader,
  OptionsSeoSettingsType,
  OptionsSocialMediaType,
  popupType,
  TemplateRoutingSettings,
} from "@/types/OptionType";
import { Footer } from "../components/Footer/Footer";
import { Header } from "../components/Header/Header/Header";
import { Navbar, NavbarOptionType } from "../components/Navbar/Navbar";
import { getInsta } from "../wp/getInsta";
import { ParentsType } from "../wp/getParentPages";
import { SearchResult } from "../components/SearchResult/SearchResult";
import { GlobalContextProvider } from "@aleksundshantu/aunds-utils-react/contexts";
import MotionPopUp from "../components/PopUp/PopUp";

import {
  DEFAULT_SETTING,
  getIndexedPostSliderData,
  IndexedPostSlidereData,
} from "../getData/getIndexedPostSliderData";
import { useRef } from "react";
import type { Module as ModuleType } from "@aleksundshantu/schirdewan-standard-types/acf-module";
import autoLinkGlossarTerms from "@/utils/glossary/glossaryLinking";
import GlossarTooltip from "@/components/GlossarTooltip/GlossarTooltip.tsx";
import { EphemeralStore, EphemeralStoreKey } from "@/utils/ephemeralStore.ts";

import { useAppContext } from "@/context/AppContext";
import { PostTreeItem } from "@/wp/types/client";
import { Post } from "@aleksundshantu/schirdewan-standard-types/client";
import {
  getIndexedFormsData,
  IndexedFormsData,
} from "@/getData/getIndexedFormsData";
import {
  BreakpointsOptionsType,
  getBreakpointsFromOptions,
} from "@/getData/getBreakpoints";
import {
  getTeaserSliderData,
  TeaserSliderDataType,
} from "@/getData/getTeaserSliderData";
import {
  getFullWidthSliderData,
  MultipleFullWidthSliderDataType,
} from "@/getData/getFullWidthSliderData";
import {
  getQuotesSliderData,
  QuotesSliderDataType,
} from "@/getData/getQuotesSliderData";
import {
  getLogoSliderData,
  LogoSliderDataType,
} from "@/getData/getLogoSliderData";
import {
  getIndexedEventSliderData,
  IndexedEventSliderData,
} from "@/getData/getIndexedEventSliderData";
import { Modal } from "@/modules/Insta/Modal/Modal";
import { getTemplateRouting } from "@/wp/getTemplateRouting";
import {
  getIndexedNewsletterData,
  IndexedNewsletterData,
} from "@/getData/getIndexedNewsletterData";
import {
  getIndexedContactData,
  IndexedContactData,
} from "@/getData/getContactTeamData";
import {
  getPostGridCatData,
  PostGridCategories,
} from "../getData/getIndexedPostGridData";
import { getCategoryOverviewSettings } from "@/getData/getCategoryOverviewSettings";
import { getPostForType, getCategoryBySlug } from "@/wp/getPosts";
import { getHeaderVideoData } from "@/getData/getHeaderVideoData";
import { Header_Startseite } from "@aleksundshantu/schirdewan-standard-types/acf-header";
import PostSliderModule from "@/modules/PostSlider/PostSlider";
import EventSliderModule from "@/modules/EventSlider/EventSlider";

type Module = ModuleType["module"][number];

interface DynamicPageProps {
  locale: string;
  defaultLocale: string;
  pageData: Post;
  legalMenu: MenuType;
  mainMenu: MenuType;
  // TODO: Never pass full options object to page props
  // options: OptionsType;
  categories: CategoryType[];
  headerOptions: HeadersOptionsType;
  moduleOptions: ModuleOptionsType;
  socialMedia: OptionsSocialMediaType;
  footerOptions: OptionsFooterType;
  breakpoints: BreakpointsOptionsType | null;
  navbarOption: NavbarOptionType;
  labels: LabelsType;
  footerMenu: MenuType;
  startPageOptions: StartPageType;
  insta: string;
  parents: ParentsType;
  allTeaserData: TeaserSliderDataType[];
  allFullWidthSliderData: MultipleFullWidthSliderDataType[];
  newsletterOptions: NewsLetterOptionType;
  icons: IconsType;
  searchOptions: OptionsSearchType;
  allQuotesData: QuotesSliderDataType[];
  allLogosData: LogoSliderDataType[];
  popupOptions: popupOptionType;
  popupData: popupType;
  endCards: OptionsEndCardsType;
  indexedEventSliderData: IndexedEventSliderData;
  indexedPostSliderData: IndexedPostSlidereData;
  indexedNewsletterData: IndexedNewsletterData;
  headerThemeOptions: OptionsHeaderType;
  securityHeaderOptions: OptionsSecurityHeader;
  googleMapThemeOptions: OptionsGoogleMapType;
  seoSettingsOptions: OptionsSeoSettingsType;
  indexedFormsData: IndexedFormsData;
  formBulderOptions: OptionsType["acf"]["form_builder"];
  routing: TemplateRoutingSettings;
  indexedContactData: IndexedContactData;
  PostGridCategories: PostGridCategories;
}

export default function DynamicPage({
  // TODO: Never pass full options object to page props
  locale,
  defaultLocale,
  pageData,
  headerOptions,
  moduleOptions,
  socialMedia,
  footerOptions,
  breakpoints,
  mainMenu,
  navbarOption,
  labels,
  footerMenu,
  legalMenu,
  startPageOptions,
  insta,
  parents,
  allTeaserData,
  allFullWidthSliderData,
  allQuotesData,
  newsletterOptions,
  icons,
  searchOptions,
  allLogosData,
  popupOptions,
  popupData,
  endCards,
  indexedEventSliderData,
  indexedPostSliderData,
  headerThemeOptions,
  securityHeaderOptions,
  googleMapThemeOptions,
  indexedFormsData,
  indexedNewsletterData,
  formBulderOptions,
  seoSettingsOptions,
  routing,
  indexedContactData,
  PostGridCategories,
}: DynamicPageProps) {
  const popupRef = useRef<HTMLDivElement>(null);
  const mainstartAriaLabel = labels?.find(
    (label) => label.key === "aria_label_mainstart",
  );
  const mainstartLabel = labels?.find((label) => label.key === "skip_nav");

  const isBigParagraph =
    "header_seite" in pageData.acf
      ? pageData.acf?.header_seite?.big_paragraph
      : false;
  const { instagramModal } = useAppContext();

  return (
    <GlobalContextProvider
      iconsRaw={icons}
      labelsRaw={labels}
      locale={locale}
      defaultLocale={defaultLocale}
    >
      <HeadMeta
        post={pageData}
        securityHeaderOptions={securityHeaderOptions}
        seoSettingsOptions={seoSettingsOptions}
        routing={routing}
      />
      <div id="pagestart" tabIndex={-1} />
      {/* eslint-disable-next-line react/forbid-elements */}
      <a
        className="skipnav"
        href="#maincontent"
        {...(mainstartAriaLabel && {
          "aria-label": mainstartAriaLabel.value,
        })}
      >
        {mainstartLabel ? mainstartLabel.value : "Navigation überspringen"}
      </a>
      <Navbar
        searchPageSlug={searchOptions?.search_page_link || ""}
        menu={mainMenu}
        socialMedia={socialMedia.platforms}
        navbarOption={navbarOption}
        pageData={pageData}
        isHome={"header_startseite" in pageData.acf}
      />

      {pageData && (
        <>
          <div id="maincontent" />
          <main id={`main-tag`}>
            <Header
              locale={locale}
              startPageOptions={startPageOptions}
              post={pageData}
              headerOptions={headerOptions}
              parents={parents}
              options={headerThemeOptions}
              socialMediaThemeOptions={socialMedia}
              navbarHasBackground={
                navbarOption?.moduleOption?.header_menu?.show_background &&
                "header_startseite" in pageData.acf
              }
            />

            {pageData.acf?.module &&
              (pageData.acf.module as Array<Module>).map((module, index) => {
                const teaserSliderData = allTeaserData.find(
                  (d) => d.index === index,
                );
                const fullWidthSliderData = allFullWidthSliderData.find(
                  (d) => d.index === index,
                )?.data;
                const quotesSliderData = allQuotesData.find(
                  (d) => d.index === index,
                );

                const logoElements = allLogosData.find(
                  (d) => d.index === index,
                );

                return (
                  <Modules
                    index={index}
                    key={`${pageData.slug}-${module.acf_fc_layout}-${index}`}
                    module={module}
                    moduleOptions={moduleOptions}
                    breakpoints={breakpoints}
                    insta={insta}
                    socialMedia={socialMedia}
                    endCards={endCards}
                    teaserSliderData={
                      teaserSliderData ? teaserSliderData.data : []
                    }
                    quotesSliderData={
                      quotesSliderData ? quotesSliderData.data : []
                    }
                    fullWidthSliderData={fullWidthSliderData}
                    newsletterOptions={newsletterOptions}
                    logoElements={logoElements ? logoElements.data : []}
                    indexedEventSliderData={indexedEventSliderData}
                    indexedPostSliderData={indexedPostSliderData}
                    indexedNewsletterData={indexedNewsletterData}
                    isBigParagraph={isBigParagraph}
                    fallbackImages={headerThemeOptions.fallback_images}
                    headerOptions={headerOptions}
                    googleMapThemeOptions={googleMapThemeOptions}
                    type={pageData.type}
                    pageId={pageData.id}
                    indexedFormsData={indexedFormsData}
                    formBulderOptions={formBulderOptions}
                    indexedContactData={indexedContactData}
                    PostGridCategories={PostGridCategories}
                  />
                );
              })}
            {pageData.type === "blog" && (
              <PostSliderModule
                data={{
                  ...{
                    slider: {
                      headline_html_tag: "h2",
                      headline: "<strong>Weitere Beiträge</strong>",
                      overline: "",
                      subline: "",
                      type: "categories",
                      categories: false,
                      posts: null,
                    },
                    layout: {
                      id: "",
                      section_margin_class: "is-gapless-margin-top-bottom",
                      section_padding_class: "default",
                      background_color_class: "has-hellgrau-bg",
                      headline_text_align_class: "has-text-centered",
                      grid_columns: "two-cols",
                      module_width: "normal-frame",
                    },
                    settings: DEFAULT_SETTING,
                  },
                }}
                postsSliderOptions={moduleOptions.slider!}
                postSliderData={
                  indexedPostSliderData?.[0]?.data ?? { posts: [] }
                }
                endCardData={endCards?.slider}
              />
            )}
            {pageData.type === "events" && (
              <EventSliderModule
                data={{
                  ...{
                    events_slider: {
                      headline_html_tag: "h2",
                      headline: "<strong>Weitere Termine</strong>",
                      overline: "",
                      subline: "",
                    },
                    layout: {
                      id: "",
                      section_margin_class: "is-gapless-margin-top-bottom",
                      section_padding_class: "default",
                      background_color_class: "has-hellgrau-bg",
                      module_width: "normal-frame",
                    },
                    settings: DEFAULT_SETTING,
                  },
                }}
                eventsSliderOptions={moduleOptions.events_slider!}
                eventSliderData={
                  indexedEventSliderData?.[0]?.data ?? { posts: [] }
                }
                endCardData={endCards?.events_slider}
              />
            )}
            <SearchResult searchOptions={searchOptions} />
            <MotionPopUp
              popupOptions={popupOptions}
              popupData={popupData}
              ref={popupRef}
            />
            {instagramModal && <Modal />}
          </main>
        </>
      )}
      <Footer
        autoShowConsentManagement={
          "header_seite" in pageData.acf
            ? pageData.acf?.header_seite?.show_consent_management
            : true
        }
        footerOptions={footerOptions}
        socialMedia={socialMedia}
        footerMenu={footerMenu}
        legalMenu={legalMenu}
      />
      <GlossarTooltip key={pageData.slug} />
    </GlobalContextProvider>
  );
}

export async function getStaticPaths({}) {
  const allPaths = await globalGetStaticPaths();
  return {
    paths: allPaths,
    fallback: "blocking",
  };
}

export const isEmptyParentPage = async ({
  pageData,
  locale,
  defaultLocale,
}: {
  pageData: Post;
  locale: string;
  defaultLocale: string;
}): Promise<boolean> => {
  if (!pageData?.acf?.module && pageData.type === "page") {
    const hasChildren = await hasChildPages({
      id: pageData.id,
      locale,
      defaultLocale,
    });
    if (hasChildren) {
      return true;
    }
    return false;
  }
  return false;
};

export async function getStaticProps(context: GetStaticPropsContext) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any --- FIXME: disabled temporarily on migrate to TS.
    const { dynamicRoute }: any = context.params;
    const locale = context.locale || "de";
    const defaultLocale = context.defaultLocale || "de";

    const slug = dynamicRoute?.[dynamicRoute.length - 1];
    if (slug !== undefined && !isValidWpSlug(slug)) {
      return {
        notFound: true,
        revalidate: parseInt(process.env.REVALIDATE_AFTER || "120"),
      };
    }
    if (context.preview && typeof context.previewData !== "string") {
      return {
        notFound: true,
      };
    }

    const privatePageData = EphemeralStore.getEntry(
      context.previewData as EphemeralStoreKey,
    );
    let pageData =
      context.preview && !privatePageData.isNone
        ? privatePageData.value
        : await globalGetPageData({ dynamicRoute, locale, defaultLocale });

    let constructedPagePath, pagePath;

    if (dynamicRoute) {
      pagePath = getRelativePathFromLink(pageData?.link || "");
      constructedPagePath = `/${
        locale === defaultLocale ? "" : locale + "/"
      }${dynamicRoute.join("/")}/`;
    }

    let cachedRouting: TemplateRoutingSettings | null = null;

    if (!pageData || pagePath !== constructedPagePath) {
      const [categoryOverviewSettings, routing] = await Promise.all([
        getCategoryOverviewSettings(),
        getTemplateRouting(),
      ]);
      cachedRouting = routing;

      let specialRouteFound = false;
      const enableCategoryPath =
        categoryOverviewSettings?.acf?.aunds_enable_category_path_segment;

      if (enableCategoryPath && routing && dynamicRoute?.length === 3) {
        const blogRouting = routing["blog"];
        const blogSlug =
          blogRouting?.slugs?.[locale] || blogRouting?.slugs?.["default"];
        if (dynamicRoute[0] === blogSlug) {
          const postSlug = dynamicRoute[2];

          const [potentialPageData] = await Promise.all([
            getPostForType({
              slug: postSlug,
              type: "blog",
              locale,
              defaultLocale,
            }).then((res) => res?.[0]),
            getCategoryBySlug({
              slug: dynamicRoute[1],
              locale,
              defaultLocale,
            }),
          ]);

          if (potentialPageData) {
            pageData = potentialPageData;
            specialRouteFound = true;

            // Construct custom parents for breadcrumbs
            /*     const startSlugTitle =
              blogSlug.charAt(0).toUpperCase() + blogSlug.slice(1);
            if (categoryData) {
              parents.push(
                {
                  title: startSlugTitle,
                  url: null, // No link for start slug
                  isEmptyParentPage: false,
                },
                {
                  title: categoryData.name,
                  url: `/${
                    locale === defaultLocale ? "" : locale + "/"
                  }${blogSlug}/${categoryData.slug}`,
                  isEmptyParentPage: false,
                },
              );
            }*/
          }
        }
      }

      if (!specialRouteFound) {
        return {
          notFound: true,
          revalidate: parseInt(process.env.REVALIDATE_AFTER || "120"),
        };
      }
    }

    if (!pageData) {
      return {
        notFound: true,
        revalidate: parseInt(process.env.REVALIDATE_AFTER || "120"),
      };
    }
    if (pageData.type === "videos" || pageData.type === "audios") {
      const hasSingleView =
        pageData.type === "videos"
          ? pageData.acf?.header_videos.has_single_page
          : pageData.acf?.header_audios.has_single_page;
      if (!hasSingleView) {
        return {
          notFound: true,
          revalidate: parseInt(process.env.REVALIDATE_AFTER || "120"),
        };
      }
    }
    if (pageData && "header_startseite" in pageData.acf) {
      const headerVideoData = await getHeaderVideoData({
        header: pageData.acf.header_startseite,
        locale,
        defaultLocale,
      });
      if (headerVideoData) {
        pageData.acf.header_startseite =
          headerVideoData as Header_Startseite["header_startseite"];
      }
    }

    // Return 404 for empty parent pages
    if (await isEmptyParentPage({ pageData, locale, defaultLocale })) {
      return {
        notFound: true,
        revalidate: parseInt(process.env.REVALIDATE_AFTER || "120"),
      };
    }
    const fetchRouting = cachedRouting
      ? Promise.resolve(cachedRouting)
      : getTemplateRouting();
    const fetchOptions = getThemeOptions({ locale, defaultLocale });
    /*const fetchCategories = getCategories({
      category: "categories",
      locale: context.locale,
      defaultLocale: context.defaultLocale,
    });*/

    const fetchLegalMenu = getMenu({
      slug: context.locale ? "legal-" + context.locale : "legal",
    });
    const fetchFooterMenu = getMenu({
      slug: context.locale ? "footer-" + context.locale : "footer",
    });
    const fetchMainMenu = getMenu({
      slug: context.locale ? "main-" + context.locale : "main",
    });

    // Do not fetch all module options here. Fetch only the ones needed for the page by using _fields parameter
    const fetchModuleAllOptions = getModuleOptions();
    const fetchHeadersAllOptions = getHeadersOptions();
    const fetchFooterAllOptions = getFooterOptions();
    const fetchIconsAllOptions = getIconsOptions();
    const fetchFullWidthSliderData = getFullWidthSliderData({
      pageData,
      locale,
      defaultLocale,
    });

    const fetchTeaserData = getTeaserSliderData(
      pageData,
      locale,
      defaultLocale,
    );
    const fetchQuotesData = getQuotesSliderData(
      pageData,
      locale,
      defaultLocale,
    );
    const fetchLogosData = getLogoSliderData(pageData, locale, defaultLocale);
    const fetchContactData = getIndexedContactData({
      pageData,
      locale,
      defaultLocale,
    });

    const parents: ParentsType = [];

    const parentObject = (parent: PostTreeItem) => ({
      title: parent.breadcrumb_title || parent.title,
      url: parent.link,
      isEmptyParentPage: parent.is_empty || false,
    });
    if (pageData.type === "page") {
      pageData.post_tree?.parents?.map?.((parent: PostTreeItem) => {
        parents.push(parentObject(parent));
      });
    } else {
      pageData.post_tree?.post_type_root_parents?.map((child: PostTreeItem) => {
        parents.push(parentObject(child));
      });
      if (pageData.post_tree?.post_type_root) {
        const parent = pageData.post_tree.post_type_root;
        parents.push(parentObject(parent));
      }
    }

    // 1. Find the key, but tell TS it's a valid key of the acf object
    const dynamicHeaderKey = Object.keys(pageData.acf).find((key) =>
      key.startsWith("header_"),
    ) as keyof typeof pageData.acf | undefined;

    // 2. Now TS knows that dynamicHeaderKey (if it exists) is a safe index
    const headerData = dynamicHeaderKey ? pageData.acf[dynamicHeaderKey] : null;

    parents.push({
      title:
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (headerData as any)?.seo_settings?.breadcrumb_title ||
        pageData.title.rendered,
      url: pageData.link,
      isEmptyParentPage: false,
    });

    /* const fetchParents = getParentPages({
      nextParent: pageData.parent,
      locale,
      defaultLocale,
    });*/

    const moduleAllOptions = await fetchModuleAllOptions; //first fetch all module options outside the Promise.all to allow other fetches inside Promise.all to use module options
    const themeOptions = await fetchOptions; // first fetch theme options outside the Promise.all to allow other fetches inside Promise.all to use theme options

    const fetchIndexedEventSliderData = getIndexedEventSliderData({
      pageData,
      eventsSliderOptions: moduleAllOptions?.events_slider,
      locale,
      defaultLocale,
    });
    const fetchIndexedPostSliderData = getIndexedPostSliderData({
      pageData,
      locale,
      defaultLocale,
      fallback_options:
        moduleAllOptions?.slider?.slider_options.fallback_options,
      fallback_image: themeOptions?.header.fallback_images.header_posts,
    });

    const fetchIndexedFormsData = getIndexedFormsData({
      pageData,
      locale,
      defaultLocale,
    });
    const fetchIndexedNewsletterData = getIndexedNewsletterData({
      pageData,
      newsletterOptions: themeOptions.newsletter,
      locale,
      defaultLocale,
    });

    const fetchPostGridCategories = getPostGridCatData({
      pageData,
      locale,
      defaultLocale,
    });

    const [
      legalMenu,
      mainMenu,
      headersAllOptions,
      footerMenu,
      footerAllOptions,
      iconsAllOptions,
      allTeaserData,
      allFullWidthSliderData,
      allQuotesData,
      allLogosData,
      indexedEventSliderData,
      indexedPostSliderData,
      indexedFormsData,
      indexedNewsletterData,
      routing,
      indexedContactData,
      postGridCategories,
    ] = await Promise.all([
      fetchLegalMenu,
      fetchMainMenu,
      fetchHeadersAllOptions,
      fetchFooterMenu,
      fetchFooterAllOptions,
      fetchIconsAllOptions,
      fetchTeaserData,
      fetchFullWidthSliderData,
      fetchQuotesData,
      fetchLogosData,
      fetchIndexedEventSliderData,
      fetchIndexedPostSliderData,
      fetchIndexedFormsData,
      fetchIndexedNewsletterData,
      fetchRouting,
      fetchContactData,
      fetchPostGridCategories,
    ]);

    /*
    //check if we have a "parent"/overview page for the post type
    const postTypePath = customPostTypesPathMapping.find(
      (t) => t.postType === pageData?.type && t.language === locale,
    )?.path;
    if (postTypePath) {
      const postTypeOverviewPage = (
        await getPostForType({
          slug: postTypePath,
          type: "pages",
          defaultLocale,
          locale,
          fields: "acf,link,title",
        })
      )?.[0];
      if (postTypeOverviewPage && "header_seite" in postTypeOverviewPage.acf) {
        const headerTitle = postTypeOverviewPage?.acf?.header_seite?.title;
        parents.unshift({
          isEmptyParentPage: false,
          title: headerTitle ?? "",
          url: postTypeOverviewPage?.link,
        });
      }
    }
  */
    // Get a set of all layouts used on the current page
    const uniqueModuleKeys = new Set(
      (pageData.acf?.module as Array<Module>)?.map?.(
        (module) => module?.acf_fc_layout,
      ),
    );

    let breakpoints = null;
    if (
      uniqueModuleKeys.has("textmedia") ||
      uniqueModuleKeys.has("quotes_banner")
    ) {
      breakpoints = await getBreakpointsFromOptions();
    }

    let uniqueModuleKeysArray: string[] = Array.from(uniqueModuleKeys);

    // it uniqueModuleKeysArray has newsletter thre replace it with newsletter_options
    if (uniqueModuleKeysArray.includes("newsletter")) {
      uniqueModuleKeysArray = uniqueModuleKeysArray.map((key) =>
        key === "newsletter" ? "newsletter_options" : key,
      );
    }

    let moduleOptionsForCurrentPage;
    if (moduleAllOptions) {
      // Get all module options for the current page --- DO NOT pass all module options to the page
      moduleOptionsForCurrentPage = filterObjectByArrayKeys(
        moduleAllOptions,
        uniqueModuleKeysArray,
      );
    }
    if (pageData.type === "blog" && moduleAllOptions) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any --- FIXME.
      (moduleOptionsForCurrentPage as any).slider = moduleAllOptions.slider;
    }
    if (pageData.type === "events" && moduleAllOptions) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any --- FIXME.
      (moduleOptionsForCurrentPage as any).events_slider =
        moduleAllOptions.events_slider;
    }
    const glossarHeaderOptions = headersAllOptions?.header_glossar;
    if (glossarHeaderOptions) {
      if (glossarHeaderOptions.posttypes_to_link.length > 0) {
        if (glossarHeaderOptions.posttypes_to_link.includes(pageData.type)) {
          pageData = await autoLinkGlossarTerms({
            pageData,
            locale,
            defaultLocale,
            showTooltip: glossarHeaderOptions.show_tooltip,
          });
        }
      } else {
        pageData = await autoLinkGlossarTerms({
          pageData,
          locale,
          defaultLocale,
          showTooltip: glossarHeaderOptions.show_tooltip,
        });
      }
    }

    const popupOptions = moduleAllOptions?.popup;

    const instaFeedId = themeOptions.social_media.instagram_feed_id;
    const insta = await getInsta(instaFeedId || "1");
    return {
      props: {
        locale,
        defaultLocale,
        pageData,
        legalMenu,
        footerMenu,
        mainMenu,
        headerOptions: headersAllOptions,
        moduleOptions: moduleOptionsForCurrentPage,
        socialMedia: themeOptions.social_media,
        footerOptions: { ...themeOptions.footer, ...footerAllOptions },
        endCards: themeOptions.end_cards,
        breakpoints,
        navbarOption: {
          themeOption: themeOptions.header,
          moduleOption: moduleAllOptions?.navigation,
        },
        labels: themeOptions.labels || [],
        icons: iconsAllOptions,
        startPageOptions: !dynamicRoute ? moduleAllOptions?.startpage : null,
        insta,
        parents,
        allTeaserData,
        allFullWidthSliderData,
        allQuotesData,
        newsletterOptions: themeOptions.newsletter,
        searchOptions: themeOptions.search,
        allLogosData,
        popupOptions,
        popupData: themeOptions.pop_up,
        indexedEventSliderData,
        indexedPostSliderData,
        indexedNewsletterData,
        headerThemeOptions: themeOptions.header,
        securityHeaderOptions: themeOptions.security_header,
        googleMapThemeOptions: themeOptions.google_maps,
        formBulderOptions: themeOptions?.form_builder,
        seoSettingsOptions: themeOptions?.seo_settings || {},
        indexedFormsData,
        routing,
        indexedContactData,
        PostGridCategories: postGridCategories,
      },
      revalidate: parseInt(process.env.REVALIDATE_AFTER || "120"),
    };
  } catch (error) {
    const { dynamicRoute: dr, locale: loc } = (context.params ?? {}) as {
      dynamicRoute?: string[];
      locale?: string;
    };
    const path =
      `/${loc === context.defaultLocale ? "" : (loc ?? "") + "/"}${(dr ?? []).join("/")}`.replace(
        "//",
        "/",
      );

    log(LogLevel.error, "SSG", {
      message: `Page failed to render`,
      path,
      error: error instanceof Error ? error.message : String(error),
      stack: error instanceof Error ? error.stack : undefined,
    });

    // Always rethrow:
    // - During build → build fails, error becomes visible
    // - At runtime (ISR) → Next.js serves cached version, no 404
    throw error;
  }
}
